export const DEFAULT_HEADER_MARKUP = {
  settings: '',
  markup: '',
};

export const DEFAULT_FOOTER_MARKUP = Object.assign(DEFAULT_HEADER_MARKUP);
